import constant from "./../../core/constant";
import Customer from "./../../controllers/customer";

const customer = [
  {
    name: "customer",
    path: "/customer",
    component: Customer,
    protected: true,
    exact: true,
    type: constant.ROUTE_TYPE_ADUSER,
  },
];

export default customer;
